var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"qrWrap"},[_c('p',{staticClass:"title"},[_vm._v("完成实名认证")]),_c('vue-qr',{staticClass:"qrStyle",staticStyle:{"display":"block"},attrs:{"text":_vm.url,"margin":0}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottomContent"},[_c('p',{staticClass:"text1"},[_vm._v("请使用手机扫码进行实名认证")])])
}]

export { render, staticRenderFns }